import { render } from "./NewNodeModal.vue?vue&type=template&id=2f747d8e&ts=true"
import script from "./NewNodeModal.vue?vue&type=script&lang=ts"
export * from "./NewNodeModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__